import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsHelp,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type MedicalFormType = PersonalIdentifierGeneralFormType;

export const MedicalGeneralSection: MedicalFormType = {
  ...commonGeneralFields,
};

export type MedicalDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt' | 'issuerCode' | 'basisForIssuingId' | 'other' | 'placeOfBirth'
>;

type MedicalDetailsDtoHelp = Omit<
  PersonalIdentifierDetailsHelp,
  'issuerCode' | 'basisForIssuingId' | 'other' | 'placeOfBirth'
>;

export type MedicalDetailsFormType = TDtoWrapper<MedicalDetailsDto, MedicalDetailsDtoHelp>;

export const MedicalDetailsSection: MedicalDetailsFormType = {
  ...omit(commonDetailsFields, 'issuerCode', 'basisForIssuingId', 'other', 'placeOfBirth'),
};

export const MedicalLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const MedicalFormSections = [
  MedicalGeneralSection,
  MedicalDetailsSection,
  MedicalLegalizedCopiesSection,
];
